package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets25 {
  internal val names_7_shoftim_11_txt: AssetResource by lazy { init_names_7_shoftim_11_txt() }

  internal val names_7_shoftim_12_txt: AssetResource by lazy { init_names_7_shoftim_12_txt() }

  internal val names_7_shoftim_13_txt: AssetResource by lazy { init_names_7_shoftim_13_txt() }

  internal val names_7_shoftim_16_txt: AssetResource by lazy { init_names_7_shoftim_16_txt() }

  internal val names_7_shoftim_17_txt: AssetResource by lazy { init_names_7_shoftim_17_txt() }

  internal val names_7_shoftim_18_txt: AssetResource by lazy { init_names_7_shoftim_18_txt() }

  internal val names_7_shoftim_20_txt: AssetResource by lazy { init_names_7_shoftim_20_txt() }

  internal val names_7_shoftim_21_txt: AssetResource by lazy { init_names_7_shoftim_21_txt() }

  internal val names_7_shoftim_txt: AssetResource by lazy { init_names_7_shoftim_txt() }

  internal val names_8_shemuel_a_01_txt: AssetResource by lazy { init_names_8_shemuel_a_01_txt() }

  internal val names_8_shemuel_a_02_txt: AssetResource by lazy { init_names_8_shemuel_a_02_txt() }

  internal val names_8_shemuel_a_03_txt: AssetResource by lazy { init_names_8_shemuel_a_03_txt() }

  internal val names_8_shemuel_a_04_txt: AssetResource by lazy { init_names_8_shemuel_a_04_txt() }

  internal val names_8_shemuel_a_09_txt: AssetResource by lazy { init_names_8_shemuel_a_09_txt() }

  internal val names_8_shemuel_a_10_txt: AssetResource by lazy { init_names_8_shemuel_a_10_txt() }

  internal val names_8_shemuel_a_17_txt: AssetResource by lazy { init_names_8_shemuel_a_17_txt() }

  internal val names_8_shemuel_a_18_txt: AssetResource by lazy { init_names_8_shemuel_a_18_txt() }

  internal val names_8_shemuel_a_19_txt: AssetResource by lazy { init_names_8_shemuel_a_19_txt() }

  internal val names_8_shemuel_a_22_txt: AssetResource by lazy { init_names_8_shemuel_a_22_txt() }

  internal val names_8_shemuel_a_25_txt: AssetResource by lazy { init_names_8_shemuel_a_25_txt() }

  internal val names_8_shemuel_a_26_txt: AssetResource by lazy { init_names_8_shemuel_a_26_txt() }

  internal val names_8_shemuel_a_txt: AssetResource by lazy { init_names_8_shemuel_a_txt() }

  internal val names_9_shemuel_b_02_txt: AssetResource by lazy { init_names_9_shemuel_b_02_txt() }

  internal val names_9_shemuel_b_03_txt: AssetResource by lazy { init_names_9_shemuel_b_03_txt() }

  internal val names_9_shemuel_b_04_txt: AssetResource by lazy { init_names_9_shemuel_b_04_txt() }

  internal val names_9_shemuel_b_05_txt: AssetResource by lazy { init_names_9_shemuel_b_05_txt() }

  internal val names_9_shemuel_b_06_txt: AssetResource by lazy { init_names_9_shemuel_b_06_txt() }

  internal val names_9_shemuel_b_07_txt: AssetResource by lazy { init_names_9_shemuel_b_07_txt() }

  internal val names_9_shemuel_b_08_txt: AssetResource by lazy { init_names_9_shemuel_b_08_txt() }

  internal val names_9_shemuel_b_09_txt: AssetResource by lazy { init_names_9_shemuel_b_09_txt() }

  internal val names_9_shemuel_b_10_txt: AssetResource by lazy { init_names_9_shemuel_b_10_txt() }

  internal val names_9_shemuel_b_11_txt: AssetResource by lazy { init_names_9_shemuel_b_11_txt() }

  internal val names_9_shemuel_b_12_txt: AssetResource by lazy { init_names_9_shemuel_b_12_txt() }

  internal val names_9_shemuel_b_13_txt: AssetResource by lazy { init_names_9_shemuel_b_13_txt() }

  internal val names_9_shemuel_b_15_txt: AssetResource by lazy { init_names_9_shemuel_b_15_txt() }

  internal val names_9_shemuel_b_16_txt: AssetResource by lazy { init_names_9_shemuel_b_16_txt() }

  internal val names_9_shemuel_b_17_txt: AssetResource by lazy { init_names_9_shemuel_b_17_txt() }

  internal val names_9_shemuel_b_18_txt: AssetResource by lazy { init_names_9_shemuel_b_18_txt() }

  internal val names_9_shemuel_b_19_txt: AssetResource by lazy { init_names_9_shemuel_b_19_txt() }

  internal val names_9_shemuel_b_20_txt: AssetResource by lazy { init_names_9_shemuel_b_20_txt() }

  internal val names_9_shemuel_b_21_txt: AssetResource by lazy { init_names_9_shemuel_b_21_txt() }

  internal val names_9_shemuel_b_23_txt: AssetResource by lazy { init_names_9_shemuel_b_23_txt() }

  internal val names_9_shemuel_b_24_txt: AssetResource by lazy { init_names_9_shemuel_b_24_txt() }

  internal val names_9_shemuel_b_txt: AssetResource by lazy { init_names_9_shemuel_b_txt() }

  internal val pyramid_questions_json: AssetResource by lazy { init_pyramid_questions_json() }

  internal val popular_searches_seed_json: AssetResource by lazy { init_popular_searches_seed_json()
      }

  internal val my_style_css: AssetResource by lazy { init_my_style_css() }

  internal val table_html: AssetResource by lazy { init_table_html() }

  internal fun values(): List<AssetResource> = listOf(names_7_shoftim_11_txt,
      names_7_shoftim_12_txt, names_7_shoftim_13_txt, names_7_shoftim_16_txt,
      names_7_shoftim_17_txt, names_7_shoftim_18_txt, names_7_shoftim_20_txt,
      names_7_shoftim_21_txt, names_7_shoftim_txt, names_8_shemuel_a_01_txt,
      names_8_shemuel_a_02_txt, names_8_shemuel_a_03_txt, names_8_shemuel_a_04_txt,
      names_8_shemuel_a_09_txt, names_8_shemuel_a_10_txt, names_8_shemuel_a_17_txt,
      names_8_shemuel_a_18_txt, names_8_shemuel_a_19_txt, names_8_shemuel_a_22_txt,
      names_8_shemuel_a_25_txt, names_8_shemuel_a_26_txt, names_8_shemuel_a_txt,
      names_9_shemuel_b_02_txt, names_9_shemuel_b_03_txt, names_9_shemuel_b_04_txt,
      names_9_shemuel_b_05_txt, names_9_shemuel_b_06_txt, names_9_shemuel_b_07_txt,
      names_9_shemuel_b_08_txt, names_9_shemuel_b_09_txt, names_9_shemuel_b_10_txt,
      names_9_shemuel_b_11_txt, names_9_shemuel_b_12_txt, names_9_shemuel_b_13_txt,
      names_9_shemuel_b_15_txt, names_9_shemuel_b_16_txt, names_9_shemuel_b_17_txt,
      names_9_shemuel_b_18_txt, names_9_shemuel_b_19_txt, names_9_shemuel_b_20_txt,
      names_9_shemuel_b_21_txt, names_9_shemuel_b_23_txt, names_9_shemuel_b_24_txt,
      names_9_shemuel_b_txt, pyramid_questions_json, popular_searches_seed_json, my_style_css,
      table_html)
}

private fun init_names_7_shoftim_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-11.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-11.txt")

private fun init_names_7_shoftim_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-12.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-12.txt")

private fun init_names_7_shoftim_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-13.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-13.txt")

private fun init_names_7_shoftim_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-16.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-16.txt")

private fun init_names_7_shoftim_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-17.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-17.txt")

private fun init_names_7_shoftim_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-18.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-18.txt")

private fun init_names_7_shoftim_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-20.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-20.txt")

private fun init_names_7_shoftim_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-21.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-21.txt")

private fun init_names_7_shoftim_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim.txt")

private fun init_names_8_shemuel_a_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-01.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-01.txt")

private fun init_names_8_shemuel_a_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-02.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-02.txt")

private fun init_names_8_shemuel_a_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-03.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-03.txt")

private fun init_names_8_shemuel_a_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-04.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-04.txt")

private fun init_names_8_shemuel_a_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-09.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-09.txt")

private fun init_names_8_shemuel_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-10.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-10.txt")

private fun init_names_8_shemuel_a_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-17.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-17.txt")

private fun init_names_8_shemuel_a_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-18.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-18.txt")

private fun init_names_8_shemuel_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-19.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-19.txt")

private fun init_names_8_shemuel_a_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-22.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-22.txt")

private fun init_names_8_shemuel_a_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-25.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-25.txt")

private fun init_names_8_shemuel_a_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a-26.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a-26.txt")

private fun init_names_8_shemuel_a_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_8_shemuel_a.txt\")") as String, rawPath =
    "peopleNames/names_8_shemuel_a.txt")

private fun init_names_9_shemuel_b_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-02.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-02.txt")

private fun init_names_9_shemuel_b_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-03.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-03.txt")

private fun init_names_9_shemuel_b_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-04.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-04.txt")

private fun init_names_9_shemuel_b_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-05.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-05.txt")

private fun init_names_9_shemuel_b_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-06.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-06.txt")

private fun init_names_9_shemuel_b_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-07.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-07.txt")

private fun init_names_9_shemuel_b_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-08.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-08.txt")

private fun init_names_9_shemuel_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-09.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-09.txt")

private fun init_names_9_shemuel_b_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-10.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-10.txt")

private fun init_names_9_shemuel_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-11.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-11.txt")

private fun init_names_9_shemuel_b_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-12.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-12.txt")

private fun init_names_9_shemuel_b_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-13.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-13.txt")

private fun init_names_9_shemuel_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-15.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-15.txt")

private fun init_names_9_shemuel_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-16.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-16.txt")

private fun init_names_9_shemuel_b_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-17.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-17.txt")

private fun init_names_9_shemuel_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-18.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-18.txt")

private fun init_names_9_shemuel_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-19.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-19.txt")

private fun init_names_9_shemuel_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-20.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-20.txt")

private fun init_names_9_shemuel_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-21.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-21.txt")

private fun init_names_9_shemuel_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-23.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-23.txt")

private fun init_names_9_shemuel_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b-24.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b-24.txt")

private fun init_names_9_shemuel_b_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_9_shemuel_b.txt\")") as String, rawPath =
    "peopleNames/names_9_shemuel_b.txt")

private fun init_pyramid_questions_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/pyramid/pyramid_questions.json\")") as String, rawPath =
    "pyramid/pyramid_questions.json")

private fun init_popular_searches_seed_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/search/popular_searches_seed.json\")") as String, rawPath =
    "search/popular_searches_seed.json")

private fun init_my_style_css(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/webview/my_style.css\")") as String, rawPath = "webview/my_style.css")

private fun init_table_html(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/webview/table.html\")") as String, rawPath = "webview/table.html")

public actual val SharedRes.assets.peopleNames.names_7_shoftim_11_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_11_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_12_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_12_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_13_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_13_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_16_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_16_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_17_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_17_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_18_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_18_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_20_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_20_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_21_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_21_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_txt: AssetResource
  get() = CommonMainAssets25.names_7_shoftim_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_01_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_01_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_02_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_02_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_03_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_03_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_04_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_04_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_09_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_09_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_10_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_10_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_17_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_17_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_18_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_18_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_19_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_19_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_22_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_22_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_25_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_25_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_26_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_26_txt

public actual val SharedRes.assets.peopleNames.names_8_shemuel_a_txt: AssetResource
  get() = CommonMainAssets25.names_8_shemuel_a_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_02_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_02_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_03_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_03_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_04_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_04_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_05_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_05_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_06_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_06_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_07_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_07_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_08_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_08_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_09_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_09_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_10_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_10_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_11_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_11_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_12_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_12_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_13_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_13_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_15_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_15_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_16_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_16_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_17_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_17_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_18_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_18_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_19_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_19_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_20_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_20_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_21_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_21_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_23_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_23_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_24_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_24_txt

public actual val SharedRes.assets.peopleNames.names_9_shemuel_b_txt: AssetResource
  get() = CommonMainAssets25.names_9_shemuel_b_txt

public actual val SharedRes.assets.pyramid.pyramid_questions_json: AssetResource
  get() = CommonMainAssets25.pyramid_questions_json

public actual val SharedRes.assets.search.popular_searches_seed_json: AssetResource
  get() = CommonMainAssets25.popular_searches_seed_json

public actual val SharedRes.assets.webview.my_style_css: AssetResource
  get() = CommonMainAssets25.my_style_css

public actual val SharedRes.assets.webview.table_html: AssetResource
  get() = CommonMainAssets25.table_html
